import { DaumPost } from "src/components/shared/models";
import ActionButtonsObjave from "./ActionButtonsObjave";
import moment from "moment";
import NoImage from "../../assets/no-image.jpg";

const ObjavaCNRList = (props: any) => {
  return (
    <>
      {props &&
        props.listaOCNR &&
        props.listaOCNR.map((lista: DaumPost) => (
          <tr key={lista.id}>
            <td className="text-secondary align-middle" style={{ width: "45%" }}>
              <div className="d-flex align-items-center">
                {lista && lista.image && lista.image.file_url ? (
                  <img className="me-2 objava-list-img" alt="post" src={lista.image.file_url} />
                ) : (
                  <img className="me-2 objava-list-img" alt="No Image" src={NoImage} />
                )}
                <span className="text-truncate d-inline-block" >
                  {lista.title && lista.title.length > 70 ? lista.title.slice(0, 70) + "..." : lista.title}
                </span>
              </div>
            </td>

            <td
              className="align-middle text-truncate"
              style={{ width: "25%", maxWidth: "300px", overflow: "hidden" }}
              dangerouslySetInnerHTML={{
                __html:
                  lista.content && lista.content.length > 150 ? lista.content.slice(0, 150) + "..." : lista.content,
              }}
            />

            <td className="align-middle text-center" style={{ width: "15%" }}>
              {moment(lista.date_created).format("DD-MM-YYYY")}
            </td>

            <td className="align-middle text-center" style={{ width: "15%" }}>
              <ActionButtonsObjave data={props.data} id={lista.id} />
            </td>
          </tr>
        ))}
    </>
  );
};

export default ObjavaCNRList;
